import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class LocalStorageService {
  get<T = object>(key: string): T {
    const serialised = localStorage.getItem(key);
    if (serialised === undefined) {
      return null;
    }
    return JSON.parse(serialised);
  }

  set(key: string, value: object) {
    const serialised = JSON.stringify(value);

    localStorage.setItem(key, serialised);
  }

  delete(key: string) {
    localStorage.removeItem(key);
  }
}
